import * as getters from './getters';
import * as actions from './actions';

export default {
  strict: true,
  state: {
    isFetchingLocations: true,
  },
  getters,
  actions,
  mutations: {
    'locations/set': (state, { path, value }) => {
      state[path] = value;
    },
  },
};
